import React, { useRef } from "react";

import {
  CalendarDays,
  MapPin,
  Video,
  ArrowRight,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

const events = [
  {
    title: "Markets Conference 2026",
    type: "Conference",
    date: "2026",
    location: "Madrid, Spain",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/events%2Fspain%2Fmadrid%2Fafme-markets-2026.jpg?alt=media&token=d3a827b4-24d9-4a48-982b-74ff872910d1",
    url: "https://www.afme.eu/events/events-calendar/",
  },

  {
    title: "Money Expo Global 2026",
    type: "Global Trading & Fintech Expo",
    date: "18–19 February 2026",
    location: "Mexico City, Mexico",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/events%2Fmexico%2Fmexico-city%2Fmoney-expo-global-2026.jpg?alt=media&token=573998f1-d782-4d54-8c43-997d5240dfa9",
    url: "https://moneyexpoglobal.com/",
  },

  {
    title: "Money20/20 Middle East 2026",
    type: "Global Fintech Conference",
    date: "14–16 September 2026",
    location: "Riyadh, Saudi Arabia",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/events%2FSaudi%20Arabia%2FRiyadh%2Fmoney2020-middle-east-2026.jpg?alt=media&token=06902fa9-0189-4ce6-8ca5-b007f705b2f0",
    url: "https://money2020middleeast.com",
  },

  {
    title: "Money20/20 USA 2026",
    type: "Fintech & Financial Services Conference",
    date: "October 18–21, 2026",
    location: "Las Vegas, USA",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/events%2Fusa%2FLasVegas%2Fmoney2020-usa.jpg?alt=media&token=f295203d-3c63-41b2-9842-a3fdf3f39845",
    url: "https://us.money2020.com/",
  },

  {
    title: "iTrading Expo Uzbekistan 2026",
    type: "FinTech, Trading & Investment Expo",
    date: "May 29–30, 2026",
    location: "Tashkent, Uzbekistan",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/events%2FUzbekistan%2FTashkent%2Fitrading-expo-uzbekistan-2026.jpg?alt=media&token=c65cb684-80fa-48ce-9201-3452457a04b0",
    url: "https://itradingexpo.com/uzbekistan/",
  },

  {
    title: "iTrading Expo Morocco 2026",
    type: "FinTech, Trading & Investment Expo",
    date: "June 6–7, 2026",
    location: "Casablanca, Morocco",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/events%2FMorocco%2FCasablanca%2Fitrading-expo-morocco-2026.jpg?alt=media&token=b5956b03-7ce4-4d93-ab18-e0b24d82a79e",
    url: "https://itradingexpo.com/morocco/",
  },
  {
    title: "iTrading Expo Miami 2026",
    type: "FinTech, Trading & Investment Expo",
    date: "October 1–2, 2026",
    location: "Miami, USA",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/events%2Fusa%2Fmiami%2Fitrading-expo-miami-2026.jpg?alt=media&token=3bf7b612-074d-49f5-a152-4f19107a0bbe",
    url: "https://itradingexpo.com/miami/",
  },
];

export default function UpcomingEvents() {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (!scrollRef.current) return;
    const amount = direction === "left" ? -360 : 360;
    scrollRef.current.scrollBy({ left: amount, behavior: "smooth" });
  };

  return (
    <section className="w-full bg-[#0B0F19] py-24">
      <div className="mx-auto max-w-6xl px-4">
        {/* Header */}
        <div className="mb-12 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-white sm:text-3xl lg:text-3xl">
              Upcoming <span className="text-blue-600">Events & Expos</span>
            </h2>
            <p className="mt-1 text-sm text-gray-400 sm:text-base">
              Connect, learn, and grow with the global market community
            </p>
          </div>

          {/* Arrows */}
          <div className="flex gap-3">
            <button
              onClick={() => scroll("left")}
              className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-900 text-white hover:bg-gray-800"
            >
              <ChevronLeft size={18} />
            </button>
            <button
              onClick={() => scroll("right")}
              className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-900 text-white hover:bg-gray-800"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        {/* Dark Container */}
        <div className="rounded-xl border border-white/5 bg-[#0B0F19] px-6 py-12 shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
          <div
            ref={scrollRef}
            className="no-scrollbar flex gap-8 overflow-x-auto scroll-smooth"
          >
            {events.map((event, idx) => (
              <a
                key={idx}
                href={event.url}
                target="_blank"
                rel="noopener noreferrer"
                className="min-w-[320px] overflow-hidden rounded-xl border border-white/10 bg-gradient-to-br from-[#12172A] to-[#0B0F19] transition-all duration-300 hover:-translate-y-1 hover:border-blue-500/40"
              >
                {/* Image */}
                <div className="h-40 bg-black">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="h-full w-full rounded-xl object-contain p-2 opacity-90"
                  />
                </div>

                {/* Content */}
                <div className="p-6">
                  <span className="mb-2 inline-block text-xs text-blue-400">
                    {event.type}
                  </span>

                  <h3 className="text-lg font-semibold text-white">
                    {event.title}
                  </h3>

                  <div className="mt-3 space-y-2 text-sm text-gray-400">
                    <div className="flex items-center gap-2">
                      <CalendarDays size={14} />
                      {event.date}
                    </div>
                    <div className="flex items-center gap-2">
                      {event.location === "Online" ? (
                        <Video size={14} />
                      ) : (
                        <MapPin size={14} />
                      )}
                      {event.location}
                    </div>
                  </div>

                  <div className="mt-5 inline-flex items-center gap-2 text-sm text-blue-400">
                    View Details
                    <ArrowRight size={14} />
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
        <div className="mx-auto mt-1 max-w-4xl text-center text-xs text-gray-400">
          Event details are sourced from official organizers and public
          announcements. Dates, locations, and availability may change. Please
          verify on the official event website.
        </div>
      </div>
    </section>
  );
}
